import {unsafe_selectWithState} from '../../redux/utils'
import {isLicenseExpired, isLicenseTrialWithoutRenewal} from '../../activeLicenseInfo/selectors'

export default function isTrialWithoutRenewal() {
    return unsafe_selectWithState(isLicenseTrialWithoutRenewal) && !unsafe_selectWithState(isLicenseExpired)
}


// WEBPACK FOOTER //
// ./web/js/userEvents/checks/isTrialWithoutRenewal.js